import React, {Component} from 'react'
import {Link} from 'react-router'
import Youtube from '../../Component/Youtube'


import DrainFlyPhoto from '../../images/Drain_Fly.jpg'

const Jeyu = {
  DrainFlyBox: {
    background:'#9e3030',
    padding: '183px 10px 140px'

  },
  bannerPhotoBox: {
    width: 200,
    height: 200,
    overflow: 'hidden',
    borderRadius: 150,
    boxShadow: '1px 1px 7px rgba(0,0,0,.2)'
  },
  bannerPhoto: {
    width: 200,
    height: 200,
  },
  center: {
   display: 'block',
   textAlign: 'left'
  },
  h1: {
    fontSize: 30,
    textAlign: 'left',
    fontWeight: 'unset',
    color: '#fff',
    margin: '10px 0 0 0'
  },
  p: {
    fontSize: 20,
    color: '#fff',
    textAlign: 'left',
    margin: 0,
    fontWeight: 100
  },
  pinfo: {
    fontSize: 18,
    textAlign: 'left',
    margin: '20px 0',
    fontWeight: 100
  },
  h2: {
    fontSize: 23,
    fontWeight: 300
  },
  tag: {
    background: 'rgb(21, 222, 203)',
    color: 'rgb(1, 72, 82)',
    padding: '2px 15px',
    borderRadius: 7,
    fontSize: 16,
    marginRight: 10,
    fontWeight: 500
  },
  time: {
    marginLeft: 10
  },
  haspt: {
    paddingTop: 17
  },
  Section: {
    padding: '0 0 20px 0'
  },
  Article: {
    padding: 15
  }
}

export default class DrainFly extends Component {
  componentDidMount () {
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    window.scrollTo(0, 0)
  }
  render() {
    return(
      <div className="container-fluid">
       <div className="row">
        <div style={Jeyu.DrainFlyBox} className="DrainFlyBox">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-6 md-8 lg-8">
            <div style={Jeyu.haspt}>
             <p style={Jeyu.p}><Link to="/" style={Jeyu.tag}>蛾蚋</Link> Jeyutex <time datetime="2017-04-13 11:44" style={Jeyu.time}>Apr 13, 2017</time></p>
             <h1 style={Jeyu.h1}>不能輕忽的騷擾性害蟲:蛾蚋!</h1>
             <p style={Jeyu.p}>蛾蚋蟲體死後風化分解混入塵埃，如果被特異體質的人呼吸吸入也會引起氣管過敏、哮喘等過敏症。</p>
             <p style={Jeyu.p}>所以看似無傷大雅的小蟲,也可能是造成您過敏的原因喔</p>
            </div>
           </div>
           <div className="xs-12 sm-6 md-4 lg-4">
            <div style={Jeyu.bannerPhotoBox} className="bannerPhotoBox">
             <img src={DrainFlyPhoto} alt="Drain Fly" style={Jeyu.bannerPhoto} className="bannerPhoto"/>
            </div>
           </div>
          </div>
         </div>
        </div>

        <div className="container">
         <div className="row">
          <section style={Jeyu.Section}>
           <article style={Jeyu.Article}>
           <sub>參考文獻: wiki百科 / 台灣環境有害生物管理協會</sub>
            <h2 style={Jeyu.h2}>蛾蚋(drain fly) - 學名 (Psychodidae)</h2>
            <p style={Jeyu.pinfo}>
             又稱蛾蠓科、毛蠓科，俗稱蛾蠅、蛾蚋，是一種小的雙翅目昆蟲，多毛的身體和翅膀給它們一個毛茸茸的外觀。<br />
             成蟲有一對長長的觸角，翅膀呈葉片狀。成年毛蠓科昆蟲大多出沒於夜間和潮濕的環境中（phlebotomines科目除外）。<br />
             幼蟲生活在水生生物棲息地（往往是含氧低的地方），包括浴缸、洗手盤等-它們都是浴室常見的滋擾性害蟲。
            </p>
            <p style={Jeyu.pinfo}>
             蛾蚋幼蟲在意外因素下，可能造成<strong>兼性蠅蛆症（facultative myiasis）</strong>。<br />
             蛾蚋最重要的“害蟲”性，是會造成<strong>蠅蛆病</strong>，而且大部份都是星斑蛾蚋所造成的。<br />
             所謂兼性寄生係指蛾蚋幼蟲在一般情形下，是一種自由生活（free living）的昆蟲，不需要寄生在宿主體內，就能完成生活史。<br />
             如果幼蟲或卵意外進入宿主體內，也能利用宿主的組織來完成生活史。
            </p>
            <p style={Jeyu.pinfo}>
             <strong>蠅蛆病（英語：Myiasis，/maɪˈaɪ.əsɨs/）</strong>是寄生蟲病的一種，由雙翅目昆蟲的幼蟲——如蒼蠅，<br />
             寄生在身體組織內導致的疾病。蛆蟲會寄生在哺乳動物身上，通常會是身體上的表面傷口，又或者身體虛弱的人的耳、鼻、口腔的組織，<br />
             使其組織受損，形成壞疽，嚴重者更可因細菌感染而致死。
            </p>
            <p>
             所以看似無害的小飛蟲, 其實是很有可能帶來比過敏還可怕的疾病喔!
            </p>
            <p>確保環境的清潔,更要從日常的生活中做起喔</p>
           </article>
          </section>
         </div>
        </div>
        <Youtube />
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/DrainFly.js